import { Location, DatePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AssetService } from '../services/asset.service';
import { MetamaskConnectService } from '../blockchainUtils/metamask-connect.service';
import { TokenSaleMarketInstanceService } from '../blockchainUtils/token-sale-market-instance.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BuyModalComponent } from './buy-modal/buy-modal.component';
import { SellModalComponent } from './sell-modal/sell-modal.component';
import Web3 from 'web3';
import { ParticipationTokenInstanceService } from 'app/blockchainUtils/participation-token-instance.service';

@Component({
  selector: 'app-asset',
  templateUrl: './asset.component.html',
  styleUrls: ['./asset.component.scss']
})
export class AssetComponent implements OnInit {
  
  availableFilters: string[] = ['Deposit', 'Payed'];
  selectedFilters: string[] = [];
  selectedFilter: string = '';
  assetsPerPage: number = 10;
  currentPage: number = 1;

  userHasParticipation: boolean = false;
  isUserOwner: boolean = false;

  assetId: number = 0;
  asset: any = {};
  userAddress: string = '';
  assetOwnerAddress: string = '';
  pool: any = {};

  loading: boolean = true;
  loadingTransaction: boolean = false;

  web3: any;

  chartData = {
    data: [[0.005, 0.007, 0.002, 0.01, 0.00004,]],
    labels: [ new Date().setDate( new Date().getDate() - 1 ),
              new Date().setDate( new Date().getDate() - 2 ),
              new Date().setDate( new Date().getDate() - 3 ),
              new Date().setDate( new Date().getDate() - 4 ),
              new Date().setDate( new Date().getDate() - 5 ),
    ],
    legends: ['Price']
  };

  constructor(
    private changeDetection: ChangeDetectorRef,
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private assetService: AssetService,
    private location: Location,
    private changeDetector: ChangeDetectorRef,
    private connectWalletService: MetamaskConnectService,
    private tokenSaleMarketInstance: TokenSaleMarketInstanceService,
    private participationTokenService: ParticipationTokenInstanceService,
    private modalService: NgbModal,
  ) { 
    this.assetId = parseInt( this.activatedRoute.snapshot.paramMap.get('id') );
    this.userAddress = localStorage.getItem('address');
  }

  ngOnInit(): void {
  }

  getPurchasesHistory( poolTokenAddress: string ) {
    return new Promise( ( resolve, reject ) => {
      this.assetService.getPurchasesHistory( poolTokenAddress ).subscribe({
        error: ( err ) => {
          console.log('[ASSET] getPurchasesHistory ERROR', err);
          reject( err );
        },
        next: ( res ) => {
          console.log('[ASSET] getPurchasesHistory SUCCESS', res);
          this.asset.purchasesHistory = res.payload;
          console.log( res.payload.length)
          resolve( res.payload );
        }
      });
    } );
  }

  getSaleInfo() {
    return new Promise( ( resolve, reject ) => {
      this.assetService.getSaleInfo( this.asset.pool_id ).subscribe({
        error: ( err ) => {
          console.log( '[ASSET] getSaleInfo ERROR', err );
          reject( err );
        },
        next: ( res ) => {
          console.log( '[ASSET] getSaleInfo SUCCESS', res );
          this.asset.saleInfo = res.payload;
          resolve( res.payload )
        }
      });
    });
  }

  updateAsset( assetId: number, data: any ) {
    return new Promise( ( resolve, reject ) => {
      this.assetService.update( assetId, data ).subscribe({
        error: ( err ) => {
          console.log('[ASSET] update ERROR', err);
          reject( err );
        },
        next: ( data ) => {
          console.log('[ASSET] update SUCCESS', data);
          resolve( data );
        }
      });
    });
  }
  
  addUsersToAsset( assetId: number, userAddress: string ) {
    return new Promise( ( resolve, reject ) => {
      this.assetService.addUserToAsset( assetId, userAddress ).subscribe({
        error: ( err ) => {
          console.log('[ASSET] addUserToAsset ERROR', err);
          reject( err );
        },
        next: ( res ) => {
          console.log('[ASSET] addUserToAsset SUCCESS', res);
          resolve( res );
        }
      });
    });
  }

  getPriceHistory( poolTokenAddress: string ) {
    return new Promise( ( resolve, reject ) => {
      this.assetService.getPriceHistory( poolTokenAddress ).subscribe({
        error: ( err ) => {
          console.log( '[ASSET] getPriceHistory ERROR', err );
          reject( err );
        },
        next: ( res ) => {
          console.log( '[ASSET] getPriceHistory SUCCESS', res );
          this.asset.priceHistory = res.payload;
          this.chartData = {
            data: [ this.asset.priceHistory.map( p => Number( Web3.utils.fromWei( p.price, 'ether') ) )],
            labels: this.asset.priceHistory.map( p => new DatePipe("en-US").transform(new Date( p.createdAt ), 'dd MMM yyyy')  ),
            legends: ['Price']
          }
          resolve( res.payload );
        }
      });
    });
  }

  async sell( tokensAmount: number ) {

    this.showLoading();

    console.log( this.asset.price.toLocaleString( undefined, { minimumFractionDigits: 7, maximumFractionDigits: 18})  )

    await this.connectWalletService
      .connectWallet( window )
      .catch( err => {
        console.log( '[ASSET][CONNECTWALLET] ERROR', err )
        this.hideLoading();
        this.showErrorMessage( 'Error selling asset, please try again' );
      } );
    this.web3 = this.connectWalletService.web3;
  
    const poolTokenInstance = await this.participationTokenService.instantiate( this.web3, this.pool.participation_token_address );
    
    const approveGas = await poolTokenInstance.methods
                          .approve( this.pool.network.token_sale_market , Web3.utils.toWei( tokensAmount.toString() ) )
                          .estimateGas({ from: this.userAddress});

    await poolTokenInstance.methods
      .approve( this.pool.network.token_sale_market, Web3.utils.toWei( tokensAmount.toString() ) )
      .send( { 
        from: this.userAddress,
        gas: approveGas,
      } )
      .on('error', err => {
        console.log('[ASSET] Approve error', err);
        if( err.code === 4001 ) {
          this.hideLoading();
          this.showErrorMessage( 'Transaction rejected' );
          return;
        }
        this.hideLoading();
        this.showErrorMessage( 'Error selling asset, please try again' );
      })
      .on('receipt', res => {
        console.log('[ASSET] Approve receipt', res);
      });

    const priceInWei = this.web3.utils.toWei( this.asset.price.toLocaleString( undefined, { minimumFractionDigits: 7, maximumFractionDigits: 18} ), 'ether' );
    const minDivision = Web3.utils.toWei( (10).toString() );
    console.log('priceInWei', priceInWei );
    
    const tokenSaleMarketInstance = await this.tokenSaleMarketInstance.instantiate( this.web3, this.pool.network.token_sale_market );
    
    console.log('parametrs', this.pool.participation_token_address, priceInWei, minDivision);

    const gas = await tokenSaleMarketInstance.methods
                  .setSaleProperties( this.pool.participation_token_address, priceInWei, minDivision )
                  .estimateGas({ from: this.userAddress });
    
    await tokenSaleMarketInstance.methods
      .setSaleProperties( this.pool.participation_token_address, priceInWei, minDivision )
      .send({ 
        from: this.userAddress,
        gas,
      })
      .on('receipt', res => {
        console.log('[ASSET] setSaleProperties receipt', res);
        this.hideLoading();
        this.changeDetection.detectChanges();
        this.showSuccessMessage( 'Your asset will be listed in a few minutes!' );
      })
      .on('error', err => {
        console.log('[ASSET] setSaleProperties error', err);
        this.hideLoading();
        this.changeDetection.detectChanges();
        this.showErrorMessage(`ERROR asset couldn't be listed`);
      });

  }

  onChangeFilter() {
    this.selectedFilters.push( this.selectedFilter );
    this.availableFilters = this.availableFilters.filter( f => f !== this.selectedFilter );
    this.changeDetection.detectChanges();
  }

  deleteFilter( filter: string ){
    this.availableFilters.push( filter );
    this.selectedFilters = this.selectedFilters.filter( f => f !== filter );
    this.changeDetection.detectChanges();
  }

  goBack() {
    this.location.back();
  }

  showLoading() {
    this.loadingTransaction = true;
  }

  hideLoading() {
    this.loadingTransaction = false;
  }

  showSuccessMessage( message: string ) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 8000,
      timerProgressBar: true,
      showCloseButton: true,
    });

    Toast.fire({
      icon: 'success',
      title: this.translate.instant( message )
    });
  }

  showErrorMessage( message: string ) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 8000,
      timerProgressBar: true,
      showCloseButton: true,
    });

    Toast.fire({
      icon: 'warning',
      title: this.translate.instant( message )
    });
  }
}
